import request from "@/utils/request";

export function getGroupList(data = {}) {
  return request({
    url: "/index/get_YL_Table_ByGroup_list",
    params: {
      limit: "all",
      ...data,
    },
  });
}

// 定岗*人、缺编*人
export function getGroupPosition(data = {}) {
  return request({
    url: "/index/get_YL_Position_ByGroup_list",
    params: {
      limit: "all",
      ...data,
    },
  });
}

// 详情数据
export function getGroupProduct(data = {}) {
  return request({
    url: "/index/get_YL_Product_ByGroup_list",
    params: {
      limit: "all",
      ...data,
    },
  });
}

// 战力、创造值
export function getGroupRank(data = {}) {
  return request({
    url: "/index/get_YL_Rank_ByEmployee_list",
    params: {
      limit: "all",
      ...data,
    },
  });
}

// 战力值详情
export function getGroupRankDetail(data = {}) {
  return request({
    url: "/index/get_YL_Product_ByEmployee_list",
    params: {
      limit: "all",
      ...data,
    },
  });
}

// 客流统计
export function getCustomerData(data = {}) {
  return request({
    url: "/index/get_YL_Customer_ByShop_list",
    params: {
      limit: "all",
      ...data,
    },
  });
}
